import { createSlice } from '@reduxjs/toolkit';
import { ACTION_ADD_PHOTO_COMMIT } from '../actions/photoActions';

const draftsSlice = createSlice({
  name: 'drafts',
  initialState: {
    newEmptyVisit: '',
    currentPhoto: {},
  },
  reducers: {
    setNewEmptyVisit: (state, action) => {
      state.newEmptyVisit = action.payload;
    },
    removeNewEmptyVisit: (state) => {
      state.newEmptyVisit = '';
    },
    removeCurrentPhoto: (state) => {
      state.currentPhoto = {};
    },
  },
  extraReducers: {
    // 'visit/post': (state, action) => {
    //   const { clientId, visitId } = action.meta;
    //   if (!state.postedNotes[clientId]) {
    //     state.postedNotes[clientId] = {};
    //   }
    //   state.postedNotes[clientId][visitId] = true;
    // },
    // 'visit/post/commit': (state, action) => {
    //   const { clientId, visitId } = action.meta;
    //   delete state.postedNotes[clientId][visitId];
    // },
    [ACTION_ADD_PHOTO_COMMIT]: (state, action) => {
      const photoId = action.meta.photo.id;
      const { id } = action.payload;

      state.currentPhoto = {
        uuId: photoId,
        targetId: id,
      };
    },
  },
});

export const { setNewEmptyVisit, removeNewEmptyVisit } = draftsSlice.actions;

export default draftsSlice.reducer;
